import React, { useState } from 'react'
import { Controller } from 'react-hook-form';
import Select from 'react-select'
function SelectField({container,id,rules,min,options,input_style,type,children,value,label,
    reff,pattern,callback,label_class,label_style,icon_childer,errorsmsg,mandatory,input_wrapeer,name,control}) {
const [typeC,settypeC] = useState(type) 
const [isClearable, setIsClearable] = useState(true);
const [isSearchable, setIsSearchable] = useState(true);  
  return (
    <div className={input_wrapeer}>
    <p className={label_class} style={{...label_style}}>
                {label}{(mandatory === true || mandatory === undefined )? '*' : ''} 
              </p>
    <div className={container} style={{border:errorsmsg && container?"1px solid #F25B5B":""}}>

    {/* <Select
        className="selectBox_styles"
        classNamePrefix="select"
        isClearable={isClearable}
        isSearchable={isSearchable}
        style={{...input_style,border:errorsmsg && !container?"1px solid #F25B5B":""}}
        options={options}
        getOptionLabel={(options) => options['name']}
        getOptionValue={(options) => options['flag']}
        value={value}
        onChange={(e)=> callback(e)}
        {...children}
      /> */}
        <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field,formState:{errors}  }) => (
          <>
          <Select
            {...field}
            className="selectBox_styles"
            classNamePrefix="select"
            isClearable={isClearable}
            isSearchable={isSearchable}
            style={{...input_style,border:errorsmsg && !container?"1px solid #F25B5B":""}}
            options={options}
            getOptionLabel={(options) => options['name']}
            getOptionValue={(options) => options['flag']}
            value={value}
            onChange={(e)=> callback(e)}
          />
        {errors[name]?.message}
          </>
        )}
        
      />
    </div>
                  <p className="help is-input-danger-message">
                    {/* {errorsmsg?errorsmsg:<span>&nbsp;</span>} */}
                   
                  </p>

    </div>
  )
}

export default SelectField